import { useEffect, useState } from 'react';
import { Alert, Card, CardContent, CardHeader, CardTitle } from '@shared/ui/primitives';
import { portalMcpApi, type McpPlatformOverview } from '@/services/portalMcpApi';
import { CopyField, McpAdminPageShell, McpStatCard } from './McpAdminShell';

export function McpPlatformOverviewPage() {
  const [data, setData] = useState<McpPlatformOverview | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    portalMcpApi
      .getOverview()
      .then(setData)
      .catch((e) => setError(e instanceof Error ? e.message : 'load failed'));
  }, []);

  return (
    <McpAdminPageShell
      title="MCP 플랫폼 개요"
      description="Gateway URL, DNS·인프라 상태, Tenant MCP 활성 현황"
    >
      {error && (
        <Alert variant="error" title="오류" description={error} />
      )}
      {data && (
        <>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <McpStatCard label="Gateway" value={data.gatewayHealth} status={data.gatewayHealth === 'healthy' ? 'ok' : 'warn'} />
            <McpStatCard label="DNS" value={data.dnsStatus} status={data.dnsStatus === 'ok' ? 'ok' : 'warn'} />
            <McpStatCard label="MCP Tenant" value={`${data.activeTenants} / ${data.totalTenants}`} />
            <McpStatCard label="Tool Catalog" value={data.catalogVersion} />
          </div>
          <div className="grid gap-4 lg:grid-cols-2">
            <CopyField label="MCP Gateway URL" value={data.gatewayUrl} />
            <CopyField label="Portal MCP URL" value={data.portalMcpUrl} />
          </div>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Route53 / 인프라</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm">
              <div>{data.infrastructure.route53Record}</div>
              <div>Custom Domain: {data.infrastructure.customDomainStatus}</div>
            </CardContent>
          </Card>
          {data.recentEvents?.length > 0 && (
            <Card>
              <CardHeader>
                <CardTitle className="text-base">최근 이벤트</CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-1 text-sm">
                  {data.recentEvents.slice(0, 10).map((ev) => (
                    <li key={ev.at + ev.message}>
                      <span className="text-muted-foreground">{ev.at}</span> — {ev.message}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </McpAdminPageShell>
  );
}
